















// vue
import { defineComponent } from '@vue/composition-api';

// primevue
import Button from 'primevue/button';

// turf
import * as turf from '@turf/turf';

export default defineComponent({
    components: {
        Button,
    },
    props: {
        title: {
            type: String,
            default: '',
        },
        layerId: {
            type: Number,
            default: '',
        },
        mapbox: {
            type: Object,
        },
        actionIcon: {
            type: String,
            default: null,
        },
        utilityDrawer: {
            type: Object,
            default: null,
        },
        geoRecordType: {
            type: String,
            default: null,
        },
        geoRecordCoords: {
            type: Array,
            default: null,
        },
        toolOptions: {
            type: Object,
            default: null,
        },
        test: {
            type: Object,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
        updateUtilityDrawerState: {
            type: Function,
            default: () => {},
        },
        setIsLayerTree: {
            type: Function,
            default: () => {},
        },
    },
    setup(props: any) {
        // methods
        const actionButton = () => {
            event?.stopPropagation();
            if (props.isMobile) {
                props.updateUtilityDrawerState(false);
            }
            props.setIsLayerTree();

            if (!props.geoRecordType || !props.geoRecordCoords) return;

            let geomTypeCamel =
                props.geoRecordType.charAt(0).toLowerCase() +
                props.geoRecordType.slice(1);

            if (!turf[geomTypeCamel]) return;

            try {
                const bbox = turf.bbox(
                    turf[geomTypeCamel](props.geoRecordCoords),
                );

                if (!bbox || bbox.some(isNaN)) return;

                props.mapbox.map.fitBounds(bbox, {
                    padding: {
                        top: props.isMobile ? 50 : 200,
                        bottom: props.isMobile ? 50 : 200,
                        left: props.isMobile ? 50 : 350,
                        right: props.isMobile ? 50 : 360,
                    },
                    maxZoom: geomTypeCamel === 'point' ? 19 : 24,
                });

                props.toolOptions.$refs.SelectTool.onGeoRecordClicked(
                    {
                        id: props.test.id,
                        geometry: props.test.geoRecordGeoJson.geometry,
                    },
                    true,
                );
            } catch (error) {
                console.error('Error calculating bbox:', error);
            }
        };

        return { actionButton };
    },
});
